var intiatePayment = undefined;;

$(document).ready(function() {
    function handleResponse(res) {
        if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0300') {
            // success block
          //  console.log('suc',res);
        } else if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0398') {
            // initiated block
          //  console.log('init',res);
        } else {
            // error block
            console.log('err',res);
        }
    };

    intiatePayment = function(params) {
        
        var configJson = {
            'tarCall': false,
            'features': {
                'showPGResponseMsg': true,
                'enableExpressPay': true,
                'enableNewWindowFlow': true,    //for hybrid applications please disable this by passing false
                'enableAbortResponse': true
            },
            'consumerData': {
                'deviceId': params.deviceId, //'WEBSH2',  //possible values 'WEBSH1', 'WEBSH2' and 'WEBMD5'
                'token': params.token, //'1f003a40f6678d655d2819552a629c23df92d24b328fbba97faa500bf308246eec308eab9b09c45dffbf670d5e090b40d55f9894d3f954e388bb9e0f980e1009',
                'returnUrl': params.returnUrl, //'http://localhost:8082/bmw/payment/techprocess/checkoutjs/response',
                'responseHandler': handleResponse,
                'paymentMode': 'all',
                'cartDescription':params.cartDescription,
                'merchantLogoUrl': 'https://www.paynimo.com/CompanyDocs/company-logo-md.png',  //provided merchant logo will be displayed
                'merchantId': params.merchantId ,//'T258915',
                'currency': params.currency, //'₹',
                'consumerId': params.consumerId, //'c42',
                'consumerMobileNo': params.consumerMobileNo, //'9746186447',
                'consumerEmailId': params.consumerEmailId, //'user@localhost.com',
                'txnId': params.txnId,//'2731538389613117',   //Unique merchant transaction ID
                'items': [{
                    'itemId': params.itemId, // 'FIRST',
                    'amount': params.amount, //'10.0',
                    'comAmt': params.comAmt //'0'
                }],
                'customStyle': {
                    'PRIMARY_COLOR_CODE': '#3977b7',   //merchant primary color code
                    'SECONDARY_COLOR_CODE': '#FFFFFF',   //provide merchant's suitable color code
                    'BUTTON_COLOR_CODE_1': '#1969bb',   //merchant's button background color code
                    'BUTTON_COLOR_CODE_2': '#FFFFFF'   //provide merchant's suitable color code for button text
                }
            }
        };

        $.pnCheckout(configJson);
        if(configJson.features.enableNewWindowFlow){
            pnCheckoutShared.openNewWindow();
        }
    }
    
});